export class CleaningConstants {
  // Polling every 5 seconds 120 times, so for 600 seconds, which is 10 minutes
  public static readonly CLEANING_REPORT_EXPORT_POLL_MAX_RETRIES = 120;
  public static readonly CLEANING_REPORT_EXPORT_POLL_INTERVAL = 5000;
}
